import { useMemo } from 'react'
import ListTableField from 'core/components/validatedForm/ListTableField'
import useClusterAccessTenants from './useClusterAccessTenants'

// See ClusterAccessField.spec.md for CAF-FR-001 through CAF-FR-004
const tenantColumns = [
  { id: 'name', label: 'Name' },
  { id: 'domain', label: 'Domain' },
  { id: 'description', label: 'Description' },
]

export interface ClusterAccessFieldProps {
  value: string[]
  onChange: (ids: string[]) => void
  className?: string
}

export default function ClusterAccessField({
  value,
  onChange,
  className,
}: ClusterAccessFieldProps) {
  const { tenants, loading, reload } = useClusterAccessTenants()
  const selectedTenants = useMemo(() => {
    const selectedIds = new Set(value)
    return tenants.filter((tenant) => selectedIds.has(tenant.id))
  }, [tenants, value])

  const handleChange = (selected: Array<{ id: string }>) => {
    // Keep ids the picker cannot show (tenants outside the viewer's scope, or not loaded yet);
    // otherwise editing the selection would silently revoke access the user never saw.
    const visibleIds = new Set(tenants.map((tenant) => tenant.id))
    const unseenIds = value.filter((id) => !visibleIds.has(id))
    onChange([...unseenIds, ...selected.map((tenant) => tenant.id)])
  }

  return (
    <div className={className}>
      <ListTableField
        id="cluster-tenant-access"
        data={tenants}
        loading={loading}
        columns={tenantColumns}
        value={selectedTenants as any} // ListTableField value type infers string[] but needs object[]
        onChange={handleChange}
        uniqueIdentifier="id"
        multiSelection
        searchTargets={['name', 'domain', 'description']}
        noRowsPerPage
        onReload={reload}
      />
    </div>
  )
}
